import { UrlObject } from 'url';

type FormattedHref = {
	pathname: string;
	query: Record<string, string>;
};

const valueIsString = (value: unknown): value is string => typeof value === 'string';

const valueIsRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === 'object' && value !== null && !Array.isArray(value);

export const formatHref = (href: string | UrlObject): FormattedHref => {
	// Si no viene como string (es UrlObject), lo normalizamos sin pasar por decodeURI.
	if (!valueIsString(href)) {
		const pathname = valueIsString(href.pathname) ? href.pathname : '/';
		const query = valueIsRecord(href.query) ? (href.query as Record<string, string>) : {};
		return { pathname, query };
	}

	try {
		const _href = decodeURI(href);
		const [pathname, query] = _href.split('?');
		const queryParams = query?.split('&').map((param) => param.split('=')) ?? [];
		return { pathname, query: Object.fromEntries(queryParams) };
	} catch {
		// href con caracteres especiales / `%` malformado → devolvemos el path tal cual.
		return { pathname: href, query: {} };
	}
};
